import { useState } from 'react';
import styles from '@features/homepage/sections/Brand/BrandSections.styles';
import BrandSlider from '@features/homepage/sections/Brand/components/BrandSlider/BrandSlider';
import { IBrandObject } from '@features/homepage/typescript';
import { ISliderItemImage, TSliderItemMediaType } from '@components/typescript';
type PropsType = {
  brand: IBrandObject;
  isFirst?: boolean;
};
const BrandSection = ({
  brand,
  isFirst = false
}: PropsType) => {
  const [firstShow, setFirstShow] = useState<boolean>(true);
  const isImageType = (item: TSliderItemMediaType): item is ISliderItemImage => (item as ISliderItemImage).type === 'image';
  const getBgContainer = (): string | null => {
    if (firstShow && brand.slides.length && isImageType(brand.slides[0]) && brand.slides[0]?.blur?.mobile) {
      return typeof brand.slides[0].blur.mobile === 'string' ? brand.slides[0].blur.mobile : brand.slides[0].blur.mobile.path;
    }
    return null;
  };
  return <section sx={styles.section(getBgContainer())} data-testid="BrandSection">
      <BrandSlider slides={brand.slides} isFirst={isFirst} firstShow={firstShow} setFirstShow={setFirstShow} />
    </section>;
};
export default BrandSection;